import React from 'react';

import i18n from 'i18n-js';
import PeopleIcon from '@material-ui/icons/People';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import SystemUpdateIcon from '@material-ui/icons/SystemUpdate';

import { NavbarList } from './NavbarList';
import NavbarListItem from './NavbarListItem';
import NavbarSectionHeader from './NavbarSectionHeader';

export default function AdminNavbar(props: { isOpen: boolean }) {
    return (
        <NavbarList isOpen={props.isOpen}>
            <NavbarSectionHeader
                isOpen={props.isOpen}
                title={i18n.t('navigationTabs.management')}
            />
            <NavbarListItem
                isOpen={props.isOpen}
                path="/users"
                icon={<PeopleIcon />}
                title={i18n.t('navigationTabs.userManagement')}
            />
            <NavbarListItem
                isOpen={props.isOpen}
                path="/restaurants"
                icon={<RestaurantIcon />}
                title={i18n.t('navigationTabs.restaurantManagement')}
                matches={['/restaurants', '/createrestaurant']}
            />
            <NavbarListItem
                isOpen={props.isOpen}
                path="/finance"
                icon={<MonetizationOnIcon />}
                title={i18n.t('navigationTabs.finance')}
            />
            <NavbarListItem
                isOpen={props.isOpen}
                path="/app-distribution"
                icon={<SystemUpdateIcon />}
                title={i18n.t('navigationTabs.appDistribution')}
            />
        </NavbarList>
    );
}
